import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

interface ConnectedProps {
  user: Insite.AppState["auth"]["user"];
}

type Props = ConnectedProps;

function mapStateToProps(state: Insite.AppState) {
  return {
    user: state.auth.user,
  };
}

const Landing = ({ user = { access: [] } }: Props) => {
  const redirectTo =
    user.access && user.access.includes("viewTriagePage")
      ? "/analysis/insights"
      : "/actions";
  return <Redirect to={redirectTo} />;
};

export default connect(mapStateToProps)(Landing);
